import * as React from 'react'
import clsx from 'clsx'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { SectionHead } from '../../_shared/SectionHead'
import { BEST_PRACTICES } from '../content'
import styles from './BestPractices.module.css'

export function BestPractices(): React.ReactElement {
  return (
    <section className={styles.section} id="bonnes-pratiques">
      <Container>
        <SectionHead
          title="Bonnes pratiques"
          lede="Règles d'utilisation du logo Ulule pour garantir la cohérence de la marque dans vos communications."
        />
        <div className={styles.grid}>
          {BEST_PRACTICES.map((practice) => (
            <div key={practice.title} className={styles.bp}>
              <span
                className={clsx(styles.bp__icon, practice.kind === 'ok' ? styles.bpIconOk : styles.bpIconNo)}
                aria-hidden="true"
              >
                {practice.kind === 'ok' ? (
                  <plume.glyphs.stroke.Check size={16} />
                ) : (
                  <plume.glyphs.stroke.Close size={16} />
                )}
              </span>
              <div>
                <p className={styles.bp__title}>{practice.title}</p>
                <p className={styles.bp__desc}>{practice.description}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}
